import { rootApi } from "../../api/rootApi";

export const exportReportsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllExportReports: builder.mutation({
            query: ({ tenant_id, token, query }) => {
                return {
                    method: "GET",
                    url: `/tenant/export-reports/?${new URLSearchParams(query).toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                        slug: tenant_id,
                    },
                };
            },
        }),
    }),
});

export const { useGetAllExportReportsMutation } = exportReportsApi;
